<template>
  <div class="about-overlay" @click="$emit('close')">
    <div class="about-container" @click.stop>
      <div class="about-header">
        <h2>BKMS ブクマすについて</h2>
        <button class="close-button" @click="$emit('close')">×</button>
      </div>
      
      <div class="about-content">
        <div class="app-logo">
          <img src="../assets/logo.svg" alt="BKMSロゴ">
        </div>
        
        <div class="app-info">
          <h3>BKMS ブクマす</h3>
          <p class="version">バージョン: 1.0.1</p>
          <p>シンプルで使いやすいブックマーク管理ツール</p>
          <p>データはローカル保存なのでデータ漏洩の心配がありません</p>
          
          <h4>主な機能</h4>
          <ul>
            <li>ブックマークのドラッグ&amp;ドロップ配置（PCのみ）</li>
            <li>サイトタイトルとファビコンの自動取得</li>
            <li>バックアップ（エクスポート・インポート）</li>
            <li>簡単な検索機能（Google、Bing、ChatGPT）</li>
          </ul>
          
          <h4>使用方法</h4>
          <p>タイルをクリックすると、ブックマークの追加・編集ができます。</p>
          <p>空のタイルをクリックすると新規ブックマークを作成できます。</p>
          <p>タイルのメニュー（⋮）から編集や削除が行えます。</p>
          
          <h4>開発者情報</h4>
          <p>© 2025 BKMSブクマす</p>
          <p>
            <a href="https://x.com/txt365" target="_blank">X</a> | 
            <a href="https://docs.google.com/forms/d/18_i-gEARcLnarphfUQqEJ7sMpM1ZzIS9Dbs2vEOnHe8/edit">お問い合わせ</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutPage'
}
</script>

<style scoped>
.about-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.about-container {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 700px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.about-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.about-header h2 {
  margin: 0;
  font-size: 1.5rem;
  color: #345;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #999;
}

.close-button:hover {
  color: #333;
}

.about-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.app-logo {
  text-align: center;
  margin-bottom: 20px;
}

.app-logo img {
  width: 120px;
  height: auto;
}

.app-info h3 {
  margin-top: 0;
  font-size: 1.3rem;
  color: #333;
}

.version {
  color: #666;
  font-size: 0.9rem;
  margin-bottom: 20px;
}

h4 {
  margin-top: 20px;
  margin-bottom: 10px;
  color: #345;
}

ul {
  margin: 10px 0;
  padding-left: 20px;
}

li {
  margin-bottom: 6px;
}

a {
  color: rgb(0, 103, 206);
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

@media (min-width: 768px) {
  .about-content {
    flex-direction: row;
  }
  
  .app-logo {
    margin-right: 30px;
    margin-bottom: 0;
  }
}
</style>